<template>
    <v-container
        :fluid="!loading"
        :grid-list-lg="!loading"
        :fill-height="loading"
        :class="loading ? 'container-loading' : ''"
    >
        <v-layout
            wrap
            v-if="!loading"
        >
            <v-flex xs12>
                <v-slide-y-transition mode="out-in">
                    <v-layout wrap>
                        <v-flex
                            xs12
                            sm3
                            class="hidden-sm-and-down"
                        >
                            <v-slide-y-transition mode="out-in">
                                <v-card>
                                    <v-card-text>
                                        <div class="text-center mb-3">
                                            <div class="v-icon-avatar">
                                                <v-icon
                                                    dark
                                                >
                                                    $mdiAdobeAcrobat
                                                </v-icon>
                                            </div>
                                        </div>
                                        <v-list
                                            two-line
                                            subheader
                                        >
                                            <v-list-item v-if="quotation.name">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Name
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ quotation.name }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item v-if="quotation.reference_number">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Reference number
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ quotation.reference_number }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item v-if="quotation.version">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Version
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ quotation.version }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item v-if="quotation.iteration">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Iteration
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ quotation.iteration }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item v-if="quotation.created_at">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Created at
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ quotation.created_at }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>

                                            <v-list-item v-if="quotation.updated_at">
                                                <v-list-item-content>
                                                    <v-list-item-title
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        Updated at
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        :class="isDark ? 'white--text' : 'primary--text'"
                                                    >
                                                        {{ quotation.updated_at }}
                                                    </v-list-item-subtitle>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list>
                                    </v-card-text>
                                </v-card>
                            </v-slide-y-transition>
                        </v-flex>
                        <v-flex
                            xs12
                            sm12
                            md9
                        >
                            <v-slide-y-transition mode="out-in">
                                <v-card>
                                    <v-card-text>
                                        <v-tabs
                                            class="mobile-tabs"
                                            v-model="activeTab"
                                            centered
                                            icons-and-text
                                            @change="setTabParameter"
                                            mobile-break-point="320"
                                        >
                                            <v-tabs-slider color="secondary"></v-tabs-slider>

                                            <v-tab
                                                href="#info"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                            >
                                                Information
                                                <v-icon>$mdiInformationOutline</v-icon>
                                            </v-tab>

                                            <v-tab-item value="info">
                                                <item-info
                                                    v-if="activeTab === 'info'"
                                                    :item-info="quotation"
                                                ></item-info>
                                            </v-tab-item>

                                            <v-tab
                                                href="#summary"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                            >
                                                Summary
                                                <v-icon>$mdiFileTable</v-icon>
                                            </v-tab>

                                            <v-tab-item
                                                value="summary"
                                            >
                                                <my-cover-summary
                                                    v-if="activeTab === 'summary' && quotation.type === 1"
                                                    :item-info="quotation"
                                                ></my-cover-summary>
                                                <home-vantage-summary
                                                    v-if="activeTab === 'summary' && quotation.type === 2"
                                                    :item-info="quotation"
                                                ></home-vantage-summary>
                                            </v-tab-item>

<!--                                            <v-tab-->
<!--                                                href="#versions"-->
<!--                                                :class="isDark ? 'white&#45;&#45;text' : 'primary&#45;&#45;text'"-->
<!--                                            >-->
<!--                                                Versions-->
<!--                                                <v-icon>$mdiHistory</v-icon>-->
<!--                                            </v-tab>-->

<!--                                            <v-tab-item value="versions">-->
<!--                                                <item-versions-->
<!--                                                    v-if="activeTab === 'versions'"-->
<!--                                                    :item-info="quotation"-->
<!--                                                ></item-versions>-->
<!--                                            </v-tab-item>-->


                                            <v-tab
                                                v-if="typeof quotation.holders !== 'undefined' && quotation.holders.length"
                                                href="#client"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                            >
                                                Client
                                                <v-icon>$mdiAccount</v-icon>
                                            </v-tab>

                                            <v-tab-item value="client">
                                                <item-client
                                                    v-if="activeTab === 'client'"
                                                    :item-info="quotation.holders[0]"
                                                ></item-client>
                                            </v-tab-item>

                                            <v-tab
                                                v-if="typeof quotation.holders !== 'undefined' && quotation.holders.length && typeof quotation.holders[0].current_policy !== 'undefined' && quotation.holders[0].current_policy"
                                                href="#policy"
                                                :class="isDark ? 'white--text' : 'primary--text'"
                                            >
                                                Policy
                                                <v-icon>$mdiHistory</v-icon>
                                            </v-tab>

                                            <v-tab-item value="policy">
                                                <item-policy
                                                    v-if="activeTab === 'policy'"
                                                    :item-info="quotation.holders[0]"
                                                ></item-policy>
                                            </v-tab-item>
                                        </v-tabs>
                                    </v-card-text>
                                </v-card>
                            </v-slide-y-transition>
                        </v-flex>
                    </v-layout>
                </v-slide-y-transition>
            </v-flex>
        </v-layout>
        <v-layout
            v-else
            justify-center
            align-center
            column
        >
            <v-progress-circular
                :size="50"
                color="secondary"
                indeterminate
            ></v-progress-circular>
        </v-layout>
    </v-container>
</template>
<script>
    import ItemInfo from './Tabs/Info';
    import ItemVersions from './Tabs/Versions';
    import MyCoverSummary from './Tabs/MyCoverSummary';
    import HomeVantageSummary from './Tabs/HomeVantageSummary';

    import ItemClient from './Tabs/Client';
    import ItemPolicy from './Tabs/Policy';

    export default {
        data() {
            return {
                loading: true,
                quotation: null,

                activeTab: 'info',
            }
        },

        watch: {
            '$route.params.quotationId'() {
                this.getTabParameter();
                this.getQuotation();
            }
        },
        components: {
            ItemInfo,
            ItemVersions,
            MyCoverSummary,
            HomeVantageSummary,
            ItemClient,
            ItemPolicy
        },
        computed: {
            isDark() {
                return this.$vuetify.theme.dark;
            }
        },
        name: 'View-Quotation',
        mounted() {
            this.getTabParameter();
            this.getQuotation();
        },
        methods: {
            getQuotation() {
                this.loading = true;

                window.axios.post('/quotations/get', {id: this.$route.params.quotationId})
                    .then(response => {
                        this.quotation = response.data.quotation;

                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                    });
            }
        }
    }
</script>
